import { FC, useState } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { CreateWishlist } from '../../CreateWishlist'
import { WishlistCard } from './WishlistCard'
import { Wishlist } from '@pylot-data/pylotschema'
import s from '@pagestyles/Wishlist.module.scss'
import styles from './WishlistCollection.module.scss'

export type WishlistCollectionsProps = {
    wishlists: Wishlist[]
    handleSelectWishlist?: (id: string) => void
    selectedWishlist?: string
    setShowCreateForm?: () => void
    fromWishlistSidebar?: boolean
    isAddtoWishlistLoading?: boolean
}

export const WishlistCollection: FC<WishlistCollectionsProps> = ({
    wishlists,
    handleSelectWishlist,
    selectedWishlist,
    fromWishlistSidebar = false,
    setShowCreateForm = () => null,
    isAddtoWishlistLoading
}) => {
    const { t } = useTranslation(['wishlist'])
    const [showForm, setShowForm] = useState(false)

    const collectionList =
        wishlists?.length &&
        wishlists.map((wishlist, index) => {
            const { name, items_v2, id } = wishlist

            const images = items_v2?.items
                .map((item) => item?.product?.small_image?.url)
                .filter(Boolean)
                .slice(0, 4) as string[]

            return (
                <WishlistCard
                    key={index}
                    collectionIndex={images?.length || 0}
                    title={name!}
                    images={images}
                    wishlistId={id!}
                    handleSelectWishlist={handleSelectWishlist}
                    selectedWishlist={selectedWishlist}
                    isAddtoWishlistLoading={isAddtoWishlistLoading}
                />
            )
        })

    // // comentar este bloque para probar la coleccion
    if (!wishlists?.length) {
        return <div>{t('No wishlists found')}</div>
    }

    const createListButton = (
        <div
            onClick={() =>
                fromWishlistSidebar ? setShowCreateForm() : setShowForm(true)
            }
            className={styles['collection-content']}
            role="button"
            aria-label={t('Crear lista')}
            tabIndex={0}
            onKeyPress={() => null}
        >
            <div className={styles['collection-add']}>
                <span>+</span>
            </div>
            <h5 className={styles['collection-title']}>
                {t('Crear nueva lista')}
            </h5>
        </div>
    )

    const wishListContainer = (
        <>
            {!fromWishlistSidebar && (
                <div className={styles['collection-subtitle-account']}>
                    {t('wishlist|Share lists with your friends')}
                </div>
            )}
            <div className={styles['collection-container']}>
                {createListButton}
                {collectionList}
            </div>
        </>
    )

    const wishlistForm = (
        <>
            <div className={styles['collection-subtitle-account']}>
                {t(
                    'wishlist|Save your favorite products in a and create lists'
                )}
            </div>
            <CreateWishlist show={showForm} setShow={setShowForm} />
        </>
    )

    const wishlistItemsRender = showForm ? wishlistForm : wishListContainer

    return <div>{wishlistItemsRender}</div>
}
